// Copyright (c) 2017 Deere & Company

import SelectedDealers from '../state/selected-dealers';
import actions from '../actions-list';
import {getDefaultState} from '../state';
import {updateList} from '../../../shared/services/list-selections';

const updateSelectAllDealers = (state, action) => {

    const toggleSelectedDealersState = state.length ? [] : action.dealers;

    return SelectedDealers.update(state, {
        $set: toggleSelectedDealersState
    });

};

const selectAllDealersOnLoad = (state, action) =>
    SelectedDealers.update(state, {
        $set: action.dealers
    });

const updateDealerSelection = (state, action) =>
    SelectedDealers.update(state, {
        $set: updateList(
            action.dealer,
            action.isSelected,
            'account',
            state
        )
    });

export default (state = getDefaultState().selectedDealers, action) => {

    const actionTypes = {
        [actions.SELECT_ALL_OPEN_PIP_PROGRAMS_REPORT_DEALERS]: updateSelectAllDealers,
        [actions.SELECT_ALL_OPEN_PIP_PROGRAMS_REPORT_DEALERS_ON_LOAD]: selectAllDealersOnLoad,
        [actions.UPDATE_OPEN_PIP_PROGRAMS_REPORT_DEALER_SELECTION]: updateDealerSelection
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/open-pip-programs/reducers/selected-dealers.js